import { useEffect, useState } from "react";
import { AlertTriangle, LogOut } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

const KEY = "hjb_impersonation";

export function markImpersonationActive(vendorLabel?: string) {
  try {
    sessionStorage.setItem(KEY, vendorLabel || "1");
    window.dispatchEvent(new Event("hjb-impersonation-change"));
  } catch {}
}

export function ImpersonationBanner() {
  const [vendor, setVendor] = useState<string | null>(null);

  useEffect(() => {
    const read = () => {
      try {
        setVendor(sessionStorage.getItem(KEY));
      } catch {
        setVendor(null);
      }
    };
    read();
    window.addEventListener("storage", read);
    window.addEventListener("hjb-impersonation-change", read);
    return () => {
      window.removeEventListener("storage", read);
      window.removeEventListener("hjb-impersonation-change", read);
    };
  }, []);

  if (!vendor) return null;

  const exit = async () => {
    try {
      sessionStorage.removeItem(KEY);
    } catch {}
    await supabase.auth.signOut();
    window.location.href = "/auth";
  };

  return (
    <div className="fixed top-0 inset-x-0 z-[100] bg-destructive text-destructive-foreground text-sm">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <AlertTriangle className="h-4 w-4 shrink-0" />
          <span className="truncate">
            Impersonation mode — signed in as vendor{vendor !== "1" ? ` ${vendor}` : ""}. All actions are audit-logged.
          </span>
        </div>
        <button
          onClick={exit}
          className="inline-flex items-center gap-1.5 rounded-md bg-white/15 hover:bg-white/25 px-3 py-1 text-xs font-medium transition"
        >
          <LogOut className="h-3.5 w-3.5" />
          Exit impersonation
        </button>
      </div>
    </div>
  );
}
